<template>
<v-navigation-drawer app fixed clipped v-model='drawer' :width='width'>
  <v-list color='primary'>
    <template v-for='(x, i) in menuItems'>
      <v-list-tile v-if='!x.group' :key='i' :to='x.to'>
        <v-list-tile-content>
          <v-list-tile-title v-text='x.title' />
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</v-navigation-drawer>
</template>


<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    drawer: false,
  }),
  computed: {
    ...mapState(['menuItems']),
    width() {
      return _.max([window.innerWidth * 0.15, 300])
    }
  },
  beforeMount() {
    this.$root.$on('onDrawer', () => {
      this.drawer = !this.drawer
      this.$root.$emit('updateWaterStyle', this.drawer)
    })
  }
}
</script>
